import type {CHeliVoiceChannel} from './CHeliVoiceChannel';
import type {IHeliNetError} from './IHeliNetError';

export class CHeliVoiceChannelList implements IHeliNetError {
  m_vocie_channels: Array<CHeliVoiceChannel>;
  m_offset: number;
  m_limit: number | null;
  m_errorCode: string | null = null;
  m_errorData: unknown = null;

  constructor(
    vocie_channels: Array<CHeliVoiceChannel> = [],
    offset: number = 0,
    limit: number | null = null
  ) {
    this.m_vocie_channels = vocie_channels;
    this.m_offset = offset;
    this.m_limit = limit;
  }

  getList(): Array<CHeliVoiceChannel> {
    return this.m_vocie_channels.slice(
      this.m_offset,
      this.m_limit !== null ? this.m_offset + this.m_limit : undefined
    );
  }

  setError({code, data}: {code: string | null; data: unknown}) {
    this.m_errorCode = code;
    this.m_errorData = data;
  }
  getErrorCode(): string | null {
    return this.m_errorCode;
  }
  getErrorData(): unknown {
    return this.m_errorData;
  }
  isValid() {
    return this.m_errorCode === null && this.m_errorData === null;
  }
}
